import { TCreateMasterProductReqDto, TCreateMasterProductResDto } from "@/api/services/admin/master-data/product/dtos/create-master-product.dto";
import { TGetMasterProductListReqDto, TGetMasterProductListResDto } from "@/api/services/admin/master-data/product/dtos/get-master-product-list.dto";
import { TGetMasterProductResDto } from "@/api/services/admin/master-data/product/dtos/get-master-product.dto";
import { TUpdateMasterProductReqDto, TUpdateMasterProductResDto } from "@/api/services/admin/master-data/product/dtos/update-master-product.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { createUrlWithParams } from "@/utils/url";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

export const fetchMasterProductListApi = async (req: TGetMasterProductListReqDto): Promise<TGetMasterProductListResDto> => {
  const url = createUrlWithParams("/master/products", req);
  const rs = await clientApi.get<TGetMasterProductListResDto>(url);
  return rs.data;
};

export const useMasterProductList = (req: TGetMasterProductListReqDto) => {
  return useQuery({
    queryKey: [QUERY_KEYS.MASTER_DATA.FETCH_PRODUCT_LIST, req],
    queryFn: () => fetchMasterProductListApi(req),
  });
};

export const fetchMasterProductApi = async (id: string): Promise<TGetMasterProductResDto> => {
  const rs = await clientApi.get<TGetMasterProductResDto>(`/master/products/${id}`);
  return rs.data;
};

export const useMasterProduct = () => {
  const { productId } = useParams();
  return useQuery({
    queryKey: [QUERY_KEYS.MASTER_DATA.FETCH_PRODUCT_DETAIL, productId],
    queryFn: () => (productId ? fetchMasterProductApi(productId) : undefined),
    enabled: Boolean(productId),
  });
};

export const createMasterProductApi = async (payload: TCreateMasterProductReqDto): Promise<TCreateMasterProductResDto> => {
  const rs = await clientApi.post<TCreateMasterProductResDto>("/master/products", payload);
  return rs.data;
};

export const updateMasterProductApi = async (id: string, payload: TUpdateMasterProductReqDto): Promise<TUpdateMasterProductResDto> => {
  const rs = await clientApi.put<TUpdateMasterProductResDto>(`/master/products/${id}`, payload);
  return rs.data;
};
